module.exports = __webpack_public_path__ + "static/media/six.e7813684.svg";